import { render, staticRenderFns } from "./ReportCsrDesignate.vue?vue&type=template&id=839a4542"
import script from "./ReportCsrDesignate.vue?vue&type=script&lang=js"
export * from "./ReportCsrDesignate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports